import React from 'react';
import { ZapIcon } from 'lucide-react';
export function Footer() {
  return <footer className="bg-navy border-t border-border py-12" data-id="element-41">
      <div className="max-w-7xl mx-auto px-6" data-id="element-42">
        <div className="flex flex-col md:flex-row justify-between items-center gap-6" data-id="element-43">
          {/* Logo & Tagline */}
          <div className="flex flex-col items-center md:items-start gap-2" data-id="element-44">
            <div className="flex items-center gap-2 text-white font-bold text-xl tracking-tight" data-id="element-45">
              <ZapIcon className="w-6 h-6 text-primary fill-primary" data-id="element-46" />
              CONECKTA
            </div>
            <p className="text-sm text-gray-500" data-id="element-47">
              Hecho para negocios que quieren crecer sin el caos.
            </p>
          </div>

          {/* Links */}
          <div className="flex items-center gap-6 text-sm text-gray-400" data-id="element-48">
            <a href="#" className="hover:text-white transition-colors" data-id="element-49">
              Política de Privacidad
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-50">
              Términos de Servicio
            </a>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-border/50 text-center text-sm text-gray-600" data-id="element-51">
          © {new Date().getFullYear()} CONECKTA. Todos los derechos reservados.
        </div>
      </div>
    </footer>;
}